import { Highlighted } from '@starrez/starryui';
import { ColDef, ColumnState } from 'ag-grid-community';
import React from 'react';
import { IGridFormat } from '../../globalTypes';
import { toThousands } from '../../utils/formatting';
import { useServerGridContext } from './ServerPageGridContext';

export const calculateTotalPages = (pageSize: number, totalRecords: number) => {
    if (pageSize && totalRecords) {
        return Math.ceil(totalRecords / pageSize);
    }
    return 0;
};

export const buildCountLabel = (fromRecord: number, toRecord: number, ofTotalRecords: number) => {
    return `${toThousands(fromRecord)} to ${toThousands(toRecord)} of ${toThousands(ofTotalRecords)}`;
};

export const buildPageCaption = (pageNumber: number, totalPages: number) => {
    return `Page ${toThousands(pageNumber)} of ${toThousands(totalPages)}`;
};

export const buildColumnDefinitions = (cols: ColDef[]) => {
    const columns = [...cols.filter((e) => e)];
    columns
        .filter((e) => e)
        .forEach((col) => {
            HighlightCell(col);
        });
    return columns;
};

export const GetColumnStateFromGridFormat = (colState: ColumnState[], gridFormat: IGridFormat[]) => {
    let colStateWithOrder = colState.map((c) => {
        const format = gridFormat.find((f) => f.id === c.colId);
        if (format) {
            c.width = format.columnWidth;
            c.hide = !format.columnVisibility;
            return { ...c, order: format.columnOrder };
        }
        return { ...c, order: gridFormat.length - 1 };
    });

    colStateWithOrder = colStateWithOrder.sort((a, b) => a.order - b.order);
    return colStateWithOrder.map((c) => {
        const { order, ...rest } = c;
        return rest as ColumnState;
    });
};

export const HighlightCell = (col: ColDef) => {
    const { getCurrentHighlight } = useServerGridContext();
    if (!col.cellRendererFramework) {
        col.cellRendererFramework = ({ value }: IHighlightCellParams) => {
            const highlightedProps = {
                Text: (col.valueFormatter ? (col.valueFormatter as any)({ value }) : value)?.toString(),
                Highlight: getCurrentHighlight(),
            };
            return <Highlighted {...highlightedProps} />;
        };
    }
};

export interface IHighlightCellParams {
    value: any;
}
